<template>
  <div class="d-flex gap-2 snt-text-highlight">
    <slot
      v-if="text"
      name="prepend" />
    <div
      class="d-flex align-start"
      v-html="text">
    </div>
  </div>
</template>

<script>
import { escapeHTML } from 'vuetify/lib/util/helpers'

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    highlight: {
      type: String,
      default: ''
    },
    allow: Boolean
  },
  computed: {
    text () {
      const highlight = (this.highlight || '').toString().toLocaleLowerCase()
      const highlightSplit = highlight.split(' ')
      const hasHighlight = highlightSplit.some((searchWord) => this.value.toLocaleLowerCase().indexOf(searchWord) !== -1)
      if (!hasHighlight && !this.allow) {
        return ''
      }
      return this.genFilteredText(this.value)
    }
  },
  methods: {
    genFilteredText (value) {
      const text = value || ''
      if (!this.highlight) return escapeHTML(text)
      const maskedCharacters = this.getMaskedCharacters(text)
      return maskedCharacters.map(({
        start,
        preMiddle,
        middle,
        end
      }) => `${this.genWord(start)}${this.genPrefixHighlight(preMiddle)}${this.genHighlight(middle)}${this.genSuffixHighlight(end)}`).join('')
    },
    getMaskedCharacters (text) {
      let textInner = text
      const highlight = (this.highlight || '').toString().toLocaleLowerCase()
      const highlightSplit = highlight.split(' ')
      return highlightSplit.map((searchWord, i) => {
        const index = textInner.toLocaleLowerCase().indexOf(searchWord)
        if (index < 0) {
          let end = ''
          if (i === highlightSplit.length - 1) {
            end = textInner
          }
          return {
            start: '',
            preMiddle: '',
            middle: '',
            end
          }
        }
        const start = textInner.slice(0, index)
        const middle = textInner.slice(index, index + searchWord.length)
        let end = textInner.slice(index + searchWord.length, index + searchWord.length + 4)
        if (i === highlightSplit.length - 1) {
          end = textInner.slice(index + searchWord.length)
        }
        textInner = textInner.slice(index + searchWord.length + 4)
        return {
          start: start.length > 8 ? start.slice(0, 8) : '',
          preMiddle: start.length > 8 ? start.slice(start.length - 8) : start,
          middle,
          end
        }
      })
    },
    genWord (text) {
      return text ? `<span class="" style="width: 48px;">${escapeHTML(text)}</span>` : text
    },
    genPrefixHighlight (text) {
      return text ? `<span class="">${escapeHTML(text)}</span>` : text
    },
    genHighlight (text) {
      return text ? `<span class=" text--highlight">${escapeHTML(text)}</span>` : text
    },
    genSuffixHighlight (text) {
      return text ? `<span class="">${escapeHTML(text)}</span>` : text
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep {
    .text--highlight {
      color: var(--v-primary-base);
    }
  }
</style>
